(function($) {
    $(document).on('ready', function() {

        // If we're on the thank you page and the query string is available
        if (window.location.href.includes("mailing-list/?source") ) {
            let queryParameters = decodeURIComponent(window.location.href.substring(window.location.href.indexOf("?") + 1))
            let formAnalytics = {}

            // get params from query string and add to formAnalytics object
            queryParameters.split("&").forEach((param) => {
                let data = param.split("=")
                formAnalytics[data[0]] = data[1]
            })

            formAnalytics.formId = parseInt(formAnalytics.formId)
            CSAnalytics("newsletter_registered", formAnalytics)
        }
    })
})(jQuery);